import { AddOutlined, CloseOutlined, DeleteOutline } from "@material-ui/icons";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
} from "@mui/material";
import useConfirm from "../../../hooks/useConfirm";
import { useEffect, useState } from "react";

const ZoneCouverture = ({
  zoneCouverture,
  onRemoveItem,
  regions = ["resion 1", "resion 2", "resion 3"],
  onChange,
  params,
  name,
  onClickAdd,
  label,
  textValue,
  placeholder = "",
  labelButton = "Ajouter",
  error = false,
  helperText = "",
}) => {
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(textValue || null);
  const [optionRegions, setOptionRegions] = useState(regions);
  const hanldleConfirmRemove = (name) => {
    openConfirmDialog(
      "Confirmation",
      "Êtes-vous sûr de vouloir supprimer cette zone de couverture ?",
      () => {
        onRemoveItem(name);
      }
    );
  };

  useEffect(() => {
    setSelectedValue("");
  }, [open]);

  useEffect(() => {
    setOptionRegions(
      regions.filter(
        (region) => !String(zoneCouverture).split(";").includes(region)
      )
    );
  }, [zoneCouverture, regions]);

  const toggleShowCobobox = () => {
    setOpen(!open);
  };

  const handleClickAdd = () => {
    toggleShowCobobox();
    if (open) {
      onClickAdd();
    }
  };

  const handleOnComboBoxChange = (event, value, params, name) => {
    onChange(event, value, params, name);
    setSelectedValue(value);
  };

  return (
    <>
      <DialogComponent />
      <Grid
        container
        display={String(zoneCouverture).split(";").length > 0 ? "flex" : "none"}
        flexDirection={"column"}
      >
        <Grid item>
          {String(zoneCouverture)
            .split(";")
            .map(
              (zone, index) =>
                zone &&
                zone.trim() !== "" && (
                  <Grid mb={1.5} item xs={12} key={index}>
                    <Paper key={index}>
                      <Grid container p={0.25} alignItems={"center"}>
                        <Grid item xs={10} pl={1} sx={{ overflowX: "clip" }}>
                          <Tooltip title={zone}>{zone}</Tooltip>
                        </Grid>
                        <Grid item xs={2} pr={1} textAlign="right">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={(e) => hanldleConfirmRemove(zone)}
                          >
                            <DeleteOutline />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                )
            )}
        </Grid>
        <Grid item pb={2} pt={2}>
          <Grid
            container
            spacing={1}
            alignItems={"center"}
          >
            <Grid item display={open ? "" : "none"}>
              <IconButton color="error" onClick={toggleShowCobobox}>
                <CloseOutlined />
              </IconButton>
            </Grid>
            <Grid item flexGrow={1} display={open ? "" : "none"}>
              <Autocomplete
                size="small"
                disablePortal
                options={optionRegions}
                value={selectedValue}
                getOptionKey={(option) => option}
                getOptionLabel={(option) => option}
                onChange={(event, value) =>
                  handleOnComboBoxChange(event, value, params, name) || null
                }
                renderInput={(params) => (
                  <TextField
                    error={error}
                    size="small"
                    helperText={helperText}
                    {...params}
                    label={label}
                  />
                )}
              />
            </Grid>
            <Grid item /* justifyContent="right" */>
              <Button
                disabled={!selectedValue && open}
                color="primary"
                title="Ajouter"
                size="small"
                onClick={handleClickAdd}
                startIcon={open ? null : <AddOutlined />}
                variant={open ? "contained" : "outlined"}
              >
                {open ? "Ok" : labelButton || "Ajouter"}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ZoneCouverture;
